import { useState } from "react";
import { toast } from "sonner";
import { Megaphone } from "lucide-react";
import { api, errMsg, useApi, fmtDate } from "../../lib/api";
import { useAuth, hasRole } from "../../context/AuthContext";
import { SampleBadge } from "../Badges";

export const Announcements = () => {
  const { user } = useAuth();
  const canPost = hasRole(user, ["executive", "gm"]);
  const { data, reload } = useApi("/announcements");
  const [f, setF] = useState({ title: "", body: "", priority: "normal" });
  const submit = async (e) => {
    e.preventDefault();
    try {
      await api.post("/announcements", f);
      toast.success("Memo published to all staff");
      setF({ title: "", body: "", priority: "normal" });
      reload();
    } catch (err) {
      toast.error(errMsg(err));
    }
  };
  return (
    <div className="grid lg:grid-cols-3 gap-6" data-testid="announcements">
      {canPost && (
        <form onSubmit={submit} className="panel p-5 grid gap-3 h-fit" data-testid="announcement-form">
          <div className="eyebrow">Group-wide memo</div>
          <input required className="field" placeholder="Title" value={f.title} onChange={(e) => setF({ ...f, title: e.target.value })} data-testid="announcement-title-input" />
          <textarea required rows={5} className="field" placeholder="Message to all staff" value={f.body} onChange={(e) => setF({ ...f, body: e.target.value })} data-testid="announcement-body-input" />
          <select className="field" value={f.priority} onChange={(e) => setF({ ...f, priority: e.target.value })} data-testid="announcement-priority-select"><option>normal</option><option>urgent</option></select>
          <button className="btn-gold" data-testid="announcement-submit-btn">Publish memo</button>
        </form>
      )}
      <div className={`${canPost ? "lg:col-span-2" : "lg:col-span-3"} space-y-3`}>
        {(data || []).map((a) => (
          <div key={a.id} className={`panel p-5 ${a.priority === "urgent" ? "border-l-2 !border-l-red-500" : ""}`} data-testid={`announcement-${a.id}`}>
            <div className="flex items-center gap-2 mb-2"><Megaphone size={14} className="text-gold" /><span className="text-ink font-semibold">{a.title}</span>{a.priority === "urgent" && <span className="pill pill-red">urgent</span>}{a.is_sample && <SampleBadge label="Sample" />}</div>
            <p className="text-sm text-slate-300 whitespace-pre-line">{a.body}</p>
            <div className="font-data text-[10px] text-slate-500 mt-3">{a.author} · {fmtDate(a.created_at)}</div>
          </div>
        ))}
      </div>
    </div>
  );
};
